import { isMbStageName } from "../../../../Utils/leadStageType";
import LeadAgreement from "./LeadAgreement";
import { formatAbn, formatAcn, ABN_INPUT_MAX_LEN, ACN_INPUT_MAX_LEN } from "../../../../Utils/companyNumber";
import { createOperatorMemberService } from "../../../../Services/CRMAdminServices/CRMOperator";

import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState, useRef } from "react";
import { useCallback } from 'react';
import { useLocation, useParams } from "react-router-dom";
import { leadData } from "../FormData/CrmFormData";
import { Col, Label, Input, InputGroup, InputGroupText, FormGroup, Row, ListGroup, ListGroupItem } from "reactstrap";
import { Button } from "reactstrap";
import TextField from "../../../common/TextField";
import DropdownWithValueName from "../../../common/DropdownWithValueName";
import MobileField from "../../../common/MobileField";
import { toast } from "react-toastify";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { createCRMLeadCommentService, getCrmDDLService, getCRMLeadCommentService, getCrmLeadsByIdsService, updateCRMLeadsService, saveOrUpdateDiscoveryCallService, getDiscoveryCallByLeadIdService, sendDocusignService, getDocusignLogService } from "../../../../Services/CRMAdminServices/CRMTaskListService";
import DatePicker from "../../../common/DatePicker";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { H3 } from "../../../../AbstractElements";
import DollarInput from "../../../common/DollarInput";
import Dropdown from "../../../common/DropDown";
import { useSelector } from "react-redux";
import { RootState } from "../../../../ReduxToolkit/Store";
import SendSms from "./SendSms";
import FileUpload from "./FileUpload";
import DocumentList from "./DocumentList";
import StageHistory from "./StageHistory";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// import "react-toastify/dist/ReactToastify.css";
import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";
import { generateLeadHTML } from "./LeadPdf";
import SelectDatePicker from "../../../common/SelectDatePicker";
import { getAllBuildersService } from "../../../../Services/CRMAdminServices/CRMBuildersService";
import { getAllStates } from "../../../../Services/MMPClientServices/PropertySearchService";
import { getAllStagesService } from "../../../../Services/CRMAdminServices/CRMStagesService";
import {
    Document,
    Paragraph,
    Packer,
    TextRun,
    Table,
    TableRow,
    TableCell,
    WidthType,
    BorderStyle,
} from "docx";
//  import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell } from "docx";
// import DiscoveryCall from "./DiscoveryCall";
// import DiscoveryCallLead from "./DiscoveryCallLead";
// import DiscoveryCallLead, { DiscoveryCallLeadRef } from "./DiscoveryCallLead";
import FinanceDetails, { FinanceDetailsRef } from './FinanceDetails';
import StrategyModal from "./StrategyModal";
import FilterAreasSelector from "./FilterAreasSelector";
import { saveAs } from "file-saver";
import { generateTop3Doc } from "./Top3ReportDoc";
import property from '../../MMPClient/PropertySearch/property.json';

// The business is in one state, so the field is a pick, not free text.
const AU_STATES = [
    { value: "ACT", label: "ACT" },
    { value: "NSW", label: "NSW" },
    { value: "NT", label: "NT" },
    { value: "QLD", label: "QLD" },
    { value: "SA", label: "SA" },
    { value: "TAS", label: "TAS" },
    { value: "VIC", label: "VIC" },
    { value: "WA", label: "WA" },
];

export interface DiscoveryCallLeadRef {
    downloadPdf: () => void;
    runChildFunction: () => void;
}

const PROPERTY_TOP_3 = "Property Top 3";
const BUSINESS_LOAN = "Business Loan";
const MORTGAGE_MASTERY_PROGRAM = "Mortgage Mastery Program";

interface Property {
    propertyId: number;
    propertyAddress: string;
    propertyType: string;
    contractType: string;
    price1BedroomRaw: string;
    rentDollarRaw: string;
    rentYieldRaw: string;
    bedroomsRaw: string;
    bathRaw: string;
    carspotsRaw: string;
    estate: string;
    lotNumber: string;
    titled: string;
    totalPoints: number;
}

interface Top3Response {
    clientName: string;
    budgetRangeRaw: string;
    strategyRequested: string;
    propertyTypeRequested: string;
    contractTypeRequested: string;
    bedBathCarRequested: string;
    properties: Property[];
}

export default function EditLead() {
    const queryClient = useQueryClient();
    const [formData, setFormData] = useState<any>(leadData);
    const [allComments, setAllComments] = useState<any>([]);
    const [formErrors, setFormErrors] = useState<any>({});
    const navigate = useSafeNavigate();
    const location = useLocation();
    const { leadID } = useParams();
    const isMMPAssetsLiabilitiesRoute = location.pathname === '/MMPAssetsLiabilities';
    const [leadDropdownData, setLeadDropdownData] = useState<any>([])
    const [buildersOptions, setBuildersOptions] = useState<any[]>([]);
    const [filteredAgents, setFilteredAgents] = useState<any[]>([]);
    const [filterAreasData, setFilterAreasData] = useState<any[]>([]);
    const [stagesOptions, setStagesOptions] = useState<any[]>([]);

    // A lead is a mortgage broking business when it sits on an "MB -" stage.
    // The company fields only make sense for those, so they are hidden for
    // property clients rather than sitting empty on every lead.
    const selectedStageName = stagesOptions.find(
        (o: any) => String(o?.value) === String(formData?.stage)
    )?.label;
    const isMbLead = isMbStageName(selectedStageName);

    // Once a broking business signs, it stops being a prospect and becomes a
    // Platform member. This carries the details across rather than having
    // someone retype them into Add Member, and leaves a comment on the lead so
    // there is a record of when it happened.
    const isSignedMbLead = isMbLead && /signed/i.test(selectedStageName || "");
    const [isConverting, setIsConverting] = useState(false);

    const handleConvertToPlatform = async () => {
        const businessName = (formData.companyName || "").trim();
        if (!businessName) {
            toast.error("Add the company name before converting this lead.");
            return;
        }
        if (!formData.email?.trim()) {
            toast.error("Add the contact email before converting this lead.");
            return;
        }

        setIsConverting(true);
        try {
            const response: any = await createOperatorMemberService({
                businessName,
                acn: (formData.acn || "").trim() || undefined,
                abn: (formData.abn || "").trim() || undefined,
                contactName: `${formData.firstName || ""} ${formData.surname || ""}`.trim() || undefined,
                contactMobile: (formData.mobile || "").trim() || undefined,
                contactEmail: formData.email.trim(),
                firstName: (formData.firstName || "").trim(),
                surname: (formData.surname || "").trim(),
                mobile: (formData.mobile || "").trim() || undefined,
                email: formData.email.trim(),
                isActive: true,
            });

            const companyId = response?.data?.companyId ?? response?.companyId;
            toast.success("Converted to a Platform member. The owner has been emailed a set password link.");

            try {
                await createCRMLeadCommentService({
                    leadID: leadID,
                    CommentText: `Converted to Platform member${companyId ? ` (company ${companyId})` : ""}.`,
                    Staff: userData?.nameidentifier,
                    createdBy: "createdBy",
                });
                queryClient.invalidateQueries({ queryKey: ["getCRMLeadCommentService"] });
            } catch {
                // The member exists either way; a missing comment is not worth
                // failing the conversion over.
            }

            if (companyId) {
                navigate(`/OperatorMemberDetail/${companyId}`);
            }
        } catch (error: any) {
            const message = error?.response?.data?.message;
            toast.error(message || "Could not convert this lead to a Platform member.");
        } finally {
            setIsConverting(false);
        }
    };
    const [selectedAreas, setSelectedAreas] = useState<string>('');
    const userData = useSelector((state: RootState) => state.adminAuth);
    const [modal, setModal] = useState<boolean>(false);
    const [isStrategyOpen, setIsStrategyOpen] = useState(false);
    const toggle = () => setModal(!modal);
    const [isFileUploadOpen, setIsFileUploadOpen] = useState(false);
    const [isAutoSaving, setIsAutoSaving] = useState(false);

    const [privacyConsentDate, setPrivacyConsentDate] = useState<string>('');
    const [privacyConsentLog, setPrivacyConsentLog] = useState<any>(null);
    const [isSendingPrivacyConsent, setIsSendingPrivacyConsent] = useState(false);

    const [fundingSummaryDate, setFundingSummaryDate] = useState<string>('');
    const [fundingSummaryLog, setFundingSummaryLog] = useState<any>(null);
    const [isSendingFundingSummary, setIsSendingFundingSummary] = useState(false);

    const [financeMandateDate, setFinanceMandateDate] = useState<string>('');
    const [financeMandateLog, setFinanceMandateLog] = useState<any>(null);
    const [isSendingFinanceMandate, setIsSendingFinanceMandate] = useState(false);

    const { data: docusignLogData, refetch: refetchDocusignLog } = useGetRequestQuery(
        ['getDocusignLogService', leadID],
        () => getDocusignLogService(Number(leadID)),
        { enabled: !!leadID }
    );

    const {
        data: allStatesData,
        isLoading: allStatesLoading,
        isError: allStatesIsError,
    } = useGetRequestQuery(
        ["getAllStates"],
        getAllStates,
        {
            enabled: true,
        }
    );

    const handleToggleAllStates = () => {
        const statesList = allStatesData?.data || [];
        if (statesList.length === 0) return;

        const allNames: string[] = Array.from(new Set(statesList.map((s: any) => s.name).filter(Boolean) as string[]));
        const currentStates = formData.location_State_Area_Suburb
            ? formData.location_State_Area_Suburb.split(',').map((s: string) => s.trim()).filter(Boolean)
            : [];

        const isAllSelected = allNames.every((name: string) => currentStates.includes(name));

        if (isAllSelected) {
            handleValueChange("location_State_Area_Suburb", "");
        } else {
            handleValueChange("location_State_Area_Suburb", allNames.join(','));
        }
    };

    const isAllStatesSelected = () => {
        const statesList = allStatesData?.data || [];
        if (statesList.length === 0) return false;
        const allNames: string[] = Array.from(new Set(statesList.map((s: any) => s.name).filter(Boolean) as string[]));
        const currentStates = formData.location_State_Area_Suburb
            ? formData.location_State_Area_Suburb.split(',').map((s: string) => s.trim()).filter(Boolean)
            : [];
        return allNames.length > 0 && allNames.every((name: string) => currentStates.includes(name));
    };

    useEffect(() => {
        if (docusignLogData?.data && Array.isArray(docusignLogData.data) && docusignLogData.data.length > 0) {
            // "docId=1" for Privacy Consent, fallback to checking templateId or null for now
            const log1 = docusignLogData.data.find((item: any) => item.docId === 1 || item.templateId === "956b216a-fd0e-4bac-aae9-bae99c003a4d" || item.docId === null);
            if (log1) {
                setPrivacyConsentLog(log1);
                if (log1.createdDate) {
                    const dateObj = new Date(log1.createdDate);
                    const year = dateObj.getFullYear();
                    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                    const day = String(dateObj.getDate()).padStart(2, '0');
                    setPrivacyConsentDate(`${year}-${month}-${day}`);
                }
            }

            const log2 = docusignLogData.data.find((item: any) => item.docId === 2);
            if (log2) {
                setFundingSummaryLog(log2);
                if (log2.createdDate) {
                    const dateObj = new Date(log2.createdDate);
                    const year = dateObj.getFullYear();
                    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                    const day = String(dateObj.getDate()).padStart(2, '0');
                    setFundingSummaryDate(`${year}-${month}-${day}`);
                }
            }

            const log3 = docusignLogData.data.find((item: any) => item.docId === 3);
            if (log3) {
                setFinanceMandateLog(log3);
                if (log3.createdDate) {
                    const dateObj = new Date(log3.createdDate);
                    const year = dateObj.getFullYear();
                    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                    const day = String(dateObj.getDate()).padStart(2, '0');
                    setFinanceMandateDate(`${year}-${month}-${day}`);
                }
            }
        }
    }, [docusignLogData]);

    const handleSendPrivacyConsent = async () => {
        let dateToSend = privacyConsentDate;
        if (!dateToSend) {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            dateToSend = `${year}-${month}-${day}`;
            setPrivacyConsentDate(dateToSend);
        }
        setIsSendingPrivacyConsent(true);
        try {
            // Convert YYYY-MM-DD to DD/MM/YYYY for the API
            const [year, month, day] = dateToSend.split('-');
            const formattedDateToSend = `${day}/${month}/${year}`;

            await sendDocusignService(Number(leadID), 1, formattedDateToSend);
            toast.success("Privacy Consent Sent Successfully!");
            refetchDocusignLog();
        } catch (error: any) {
            toast.error(error?.response?.data || "Failed to send Privacy Consent.");
        } finally {
            setIsSendingPrivacyConsent(false);
        }
    };

    const handleSendFundingSummary = async () => {
        let dateToSend = fundingSummaryDate;
        if (!dateToSend) {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            dateToSend = `${year}-${month}-${day}`;
            setFundingSummaryDate(dateToSend);
        }
        setIsSendingFundingSummary(true);
        try {
            // Convert YYYY-MM-DD to DD/MM/YYYY for the API
            const [year, month, day] = dateToSend.split('-');
            const formattedDateToSend = `${day}/${month}/${year}`;

            await sendDocusignService(Number(leadID), 2, formattedDateToSend);
            toast.success("Funding Summary Sent Successfully!");
            refetchDocusignLog();
        } catch (error: any) {
            toast.error(error?.response?.data || "Failed to send Funding Summary.");
        } finally {
            setIsSendingFundingSummary(false);
        }
    };

    const handleSendFinanceMandate = async () => {
        let dateToSend = financeMandateDate;
        if (!dateToSend) {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            dateToSend = `${year}-${month}-${day}`;
            setFinanceMandateDate(dateToSend);
        }
        setIsSendingFinanceMandate(true);
        try {
            const [year, month, day] = dateToSend.split('-');
            const formattedDateToSend = `${day}/${month}/${year}`;

            await sendDocusignService(Number(leadID), 3, formattedDateToSend);
            toast.success("Finance Mandate Sent Successfully!");
            refetchDocusignLog();
        } catch (error: any) {
            toast.error(error?.response?.data || "Failed to send Finance Mandate.");
        } finally {
            setIsSendingFinanceMandate(false);
        }
    };

    const getDocusignStatusMessage = (status: string) => {
        if (!status) return "";
        const s = status.toLowerCase();
        if (s === 'sent' || s === 'delivered') {
            return "Document sent successfully and waiting for sign";
        }
        if (s === 'completed' || s === 'signed') {
            return "Document signed complete";
        }
        return status;
    };



    // const handleTop3Download = async () => {
    //     const loadingToast = toast.loading("⏳ Generating report, please wait...");
    //     try {
    //         // const response = await fetch("http://localhost:44907/api/Top3/generatetop3", {
    //         const response = await fetch("https://fintrack-be-gdasfffwhdhkgad2.australiaeast-01.azurewebsites.net/api/Top3/generatetop3", {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({ crmLeadId: leadID }),
    //         });

    //         if (!response.ok) {
    //             toast.dismiss(loadingToast);
    //             toast.error("⚠️ Please check all client criteria. Some details may be incomplete or no matching properties were found.");

    //             //   toast.error("⚠️ Please fill all client criteria to download the report.");
    //             return;
    //         }

    //         const data = await response.json();
    //         await generateTop3Doc(data);
    //         toast.dismiss(loadingToast);
    //     } catch (err) {
    //         console.log("Error generating report:", err);
    //         console.error("Error generating report:", err);
    //         toast.dismiss(loadingToast);
    //         toast.error("⚠️ Please fill all client criteria to download the report.");
    //     }
    // };


    const handleTop3Download = async () => {
        const loadingToast = toast.loading("⏳ Generating report, please wait...");
        try {
           
const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Top3/pdf/${leadID}`);
            if (!response.ok) {
                toast.dismiss(loadingToast);
                toast.error("⚠️ Please check all client criteria. Some details may be incomplete or no matching properties were found.");
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Top3_${leadID}_${formData.firstName}_${formData.surname?.toUpperCase()}.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            toast.dismiss(loadingToast);
            toast.success("Report downloaded successfully!");
        } catch (err) {
            console.error("Error generating report:", err);
            toast.dismiss(loadingToast);
            toast.error("⚠️ Failed to download the report.");
        }
    };
    const handleOpenLoanEnquiry = () => {
        if (!leadID) {
            toast.warn("The lead record is still loading. Please try again in a moment.");
            return;
        }
        navigate(`${process.env.PUBLIC_URL}/CRMLoanEnquiry/${leadID}`);
    };
    useEffect(() => {
        console.log('leaddata:', leadData);
        if (leadData) {
            setFormData((prev: any) => ({
                ...prev,
                leadId: leadID,
                clientName: `${leadData.firstName} ${leadData.surname}`,
                email: leadData.email || '',
                mobileNo: leadData.mobile || '',
                source: leadData.source,
                staff: leadData.staff
            }));
        }
    }, [leadData, leadID]);


    // Add state for temporary agent emails
    const [agentEmails, setAgentEmails] = useState({
        realEstateAgent1Email: '',
        realEstateAgent2Email: '',
        realEstateAgent3Email: ''
    });
    const { RoleName, RoleID, nameidentifier: userID, FirstName } = useSelector((state: RootState) => state.adminAuth);




    // Debug useEffect to track agentEmails changes
    useEffect(() => {
        console.log('Agent emails state updated:', agentEmails);
    }, [agentEmails]);

    const { data: leadsData, isLoading, isError } = useGetRequestQuery(
        ['getStaffById', leadID],
        () => getCrmLeadsByIdsService(leadID),
        { enabled: !!leadID }
    );

    const [isDataLoaded, setIsDataLoaded] = useState(false);

    useEffect(() => {
        if (leadsData && !isError && !isLoading) {
            const lead = leadsData?.data || {};
            setFormData({
                ...lead,
                propertyPurpose: (lead.propertyPurpose === null || lead.propertyPurpose === "") ? "All" : lead.propertyPurpose,
                propertyReady: (lead.propertyReady === null || lead.propertyReady === "") ? "All" : lead.propertyReady,
                area: (lead.area === null || lead.area === "" || lead.area === "Any") ? "All" : lead.area,
                state: lead.state === PROPERTY_TOP_3 ? PROPERTY_TOP_3 : "",
                suburb: lead.suburb === BUSINESS_LOAN ? BUSINESS_LOAN : "",
                suburbdigit: lead.suburbdigit === MORTGAGE_MASTERY_PROGRAM ? MORTGAGE_MASTERY_PROGRAM : "",
            });
            setIsDataLoaded(true);
            // Load existing selected areas if available
            if (leadsData?.data?.multiarea) {
                setSelectedAreas(leadsData.data.multiarea);
            }
        }
    }, [leadsData, isError, isLoading]);

    // Set agent emails when form data is loaded with existing agent selections
    useEffect(() => {
        if (formData && filteredAgents.length > 0) {
            const newAgentEmails = {
                realEstateAgent1Email: '',
                realEstateAgent2Email: '',
                realEstateAgent3Email: ''
            };
            // Check for existing agent selections and set their emails
            if (formData.realEstateAgent1) {
                const agent1 = filteredAgents.find((agent: any) =>
                    agent.value === formData.realEstateAgent1 ||
                    agent.value === parseInt(formData.realEstateAgent1) ||
                    agent.value === formData.realEstateAgent1.toString()
                );
                if (agent1 && agent1.email) {
                    newAgentEmails.realEstateAgent1Email = agent1.email;
                }
            }

            if (formData.realEstateAgent2) {
                const agent2 = filteredAgents.find((agent: any) =>
                    agent.value === formData.realEstateAgent2 ||
                    agent.value === parseInt(formData.realEstateAgent2) ||
                    agent.value === formData.realEstateAgent2.toString()
                );
                if (agent2 && agent2.email) {
                    newAgentEmails.realEstateAgent2Email = agent2.email;
                }
            }

            if (formData.realEstateAgent3) {
                const agent3 = filteredAgents.find((agent: any) =>
                    agent.value === formData.realEstateAgent3 ||
                    agent.value === parseInt(formData.realEstateAgent3) ||
                    agent.value === formData.realEstateAgent3.toString()
                );
                if (agent3 && agent3.email) {
                    newAgentEmails.realEstateAgent3Email = agent3.email;
                }
            }

            console.log('Setting agent emails from existing form data:', newAgentEmails);
            setAgentEmails(newAgentEmails);
        }
    }, [formData, filteredAgents]);

    const { data: leadsCommentData } = useGetRequestQuery<any>(
        ['getCRMLeadCommentService', leadID],
        () => getCRMLeadCommentService(leadID),
        { enabled: !!leadID }
    );

    useEffect(() => {
        if (leadsCommentData) {
            setAllComments(leadsCommentData?.data);
        }
    }, [leadsCommentData]);

    const handleValueChange = (name: string, value: string | Date | null) => {
        setFormData((prevData: any) => {
            let processedValue = value;

            // Format Beds/Baths/Cars field to enforce "3/2/2" pattern with auto-slashes
            if (name === 'location_Beds_Baths_Cars' && typeof value === 'string') {
                // Remove all characters except numbers
                let cleaned = value.replace(/[^0-9]/g, '');

                // Auto-format: add slashes automatically after 1st and 2nd digit
                if (cleaned.length > 0) {
                    let formatted = cleaned[0]; // First digit (beds)

                    if (cleaned.length > 1) {
                        formatted += '/' + cleaned[1]; // Add slash + second digit (baths)
                    }

                    if (cleaned.length > 2) {
                        formatted += '/' + cleaned[2]; // Add slash + third digit (cars)
                    }

                    // Limit to 3 digits total (which becomes "X/X/X" format)
                    processedValue = formatted;
                } else {
                    processedValue = '';
                }
            }

            const newData = {
                ...prevData,
                [name]: name === 'surname' ? (processedValue as string)?.toUpperCase() :
                    name === 'suburbdigit' ? (processedValue ? processedValue.toString() : '') : processedValue,
            };

            return newData;
        });

        // Handle agent email setting separately (not saved to formData)
        if ((name === 'realEstateAgent1' || name === 'realEstateAgent2' || name === 'realEstateAgent3') && value) {
            console.log('Agent selection detected:', name, 'Value:', value);
            console.log('Available filtered agents:', filteredAgents);

            const selectedAgent = filteredAgents.find((agent: any) =>
                agent.value === value ||
                agent.value === parseInt(value as string) ||
                agent.value === value.toString()
            );
            console.log('Selected agent found:', selectedAgent);

            if (selectedAgent && selectedAgent.email) {
                const emailFieldName = name === 'realEstateAgent1' ? 'realEstateAgent1Email' :
                    name === 'realEstateAgent2' ? 'realEstateAgent2Email' :
                        'realEstateAgent3Email';
                console.log('Setting email for field:', emailFieldName, 'Email:', selectedAgent.email);
                setAgentEmails(prev => ({
                    ...prev,
                    [emailFieldName]: selectedAgent.email
                }));
            } else {
                // Clear email if no agent selected or no email found
                const emailFieldName = name === 'realEstateAgent1' ? 'realEstateAgent1Email' :
                    name === 'realEstateAgent2' ? 'realEstateAgent2Email' :
                        'realEstateAgent3Email';
                console.log('Clearing email for field:', emailFieldName);
                setAgentEmails(prev => ({
                    ...prev,
                    [emailFieldName]: ''
                }));
            }
        } else if ((name === 'realEstateAgent1' || name === 'realEstateAgent2' || name === 'realEstateAgent3') && !value) {
            // Clear email when agent is deselected
            const emailFieldName = name === 'realEstateAgent1' ? 'realEstateAgent1Email' :
                name === 'realEstateAgent2' ? 'realEstateAgent2Email' :
                    'realEstateAgent3Email';
            console.log('Clearing email for field (no value):', emailFieldName);
            setAgentEmails(prev => ({
                ...prev,
                [emailFieldName]: ''
            }));
        }

        setFormErrors((prevErrors: any) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const { data: leadsDataDDL, isLoading: DDLloading } = useGetRequestQuery<any>(
        ['getCrmDDLService'],
        () => getCrmDDLService(),
        { enabled: true }
    );

    const {
        data: allStagesDataResponse,
        isLoading: stagesLoading,
        isError: stagesIsError,
    } = useGetRequestQuery<any>(
        ["getAllStagesService"],
        getAllStagesService,
        { enabled: true }
    );

    useEffect(() => {
        if (allStagesDataResponse && !stagesIsError && !stagesLoading) {
            const rawStages = Array.isArray(allStagesDataResponse?.data?.data)
                ? allStagesDataResponse.data.data
                : Array.isArray(allStagesDataResponse?.data)
                    ? allStagesDataResponse.data
                    : [];

            const transformedStages = rawStages
                .filter((stage: any) => !stage.isDeleted)
                .map((stage: any) => ({
                    value: stage.stageId.toString(),
                    label: stage.name,
                    orderBy: stage.orderBy
                }));

            const sorted = transformedStages.sort((a: any, b: any) => {
                const orderA = a.orderBy !== undefined && a.orderBy !== null ? Number(a.orderBy) : 999;
                const orderB = b.orderBy !== undefined && b.orderBy !== null ? Number(b.orderBy) : 999;
                return orderA - orderB;
            });

            setStagesOptions(sorted);
        }
    }, [allStagesDataResponse, stagesIsError, stagesLoading]);

    useEffect(() => {
        if (leadsDataDDL?.data && !DDLloading) {
            const ddl = leadsDataDDL.data;
            const sortedDdl = { ...ddl };
            if (Array.isArray(sortedDdl.leadSources)) sortedDdl.leadSources.sort((a: any, b: any) => (a.label || "").localeCompare(b.label || ""));
            if (Array.isArray(sortedDdl.staff)) sortedDdl.staff.sort((a: any, b: any) => (a.label || "").localeCompare(b.label || ""));
            if (Array.isArray(sortedDdl.allStages)) sortedDdl.allStages.sort((a: any, b: any) => (a.label || "").localeCompare(b.label || ""));
            
            setLeadDropdownData(sortedDdl);
        }
    }, [leadsDataDDL]);

    const {
        mutate: manageLead,
        isPending: isManageLeadPending,
    } = useMutationRequestQuery("updateCRMLeadsService", updateCRMLeadsService, {
        onSuccess: () => {
            toast.success("Lead Updated successfully.");
            // navigate('/CRMTaskList');
            queryClient.invalidateQueries({ queryKey: ["getCrmLeads"] });
        },
        onError: () => {
            toast.error("Failed to edit lead.");
        },
    });

    const handleSubmit = (e: any) => {
        e.preventDefault();
        let errors: any = {};
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (formData.email && !emailPattern.test(formData.email)) {
            errors.email = "Please enter a valid email address!";
        }
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        const submitData = {
            ...formData,
            propertyPurpose: (formData.propertyPurpose === "All" || !formData.propertyPurpose) ? "" : formData.propertyPurpose,
            propertyReady: (formData.propertyReady === "All" || !formData.propertyReady) ? "" : formData.propertyReady,
            area: (formData.area === "All" || formData.area === "Any" || !formData.area) ? "" : formData.area,
            state: formData.state === PROPERTY_TOP_3 ? PROPERTY_TOP_3 : "",
            suburb: formData.suburb === BUSINESS_LOAN ? BUSINESS_LOAN : "",
            suburbdigit: formData.suburbdigit === MORTGAGE_MASTERY_PROGRAM ? MORTGAGE_MASTERY_PROGRAM : "",
            multiarea: selectedAreas
        };
        manageLead({ leadID: leadID, data: submitData });
    };

    const {
        mutate: updateLeadComment,
        isPending: isUpdateCommentPending,
    } = useMutationRequestQuery("createCRMLeadCommentService", createCRMLeadCommentService, {
        onSuccess: () => {
            toast.success("Comment updated successfully.");
            queryClient.invalidateQueries({ queryKey: ["getCRMLeadCommentService"] });
            // Clear the comment field after successful submission
            setFormData((prevData: any) => ({
                ...prevData,
                comment: ""
            }));
        },
        onError: () => {
            toast.error("Failed to update comment.");
        },
    });

    const handleAddComment = () => {
        if (!formData.comment?.trim()) {
            toast.error("Comment cannot be empty.");
            return;
        }

        updateLeadComment({
            leadID: leadID,
            CommentText: formData.comment,
            Staff: userData?.nameidentifier,
            createdBy: "createdBy",
        });
    };


    const toggleFileUpload = () => {
        setIsFileUploadOpen(!isFileUploadOpen);
    };



    const pdfRef = useRef<HTMLDivElement>(null);



    const handleDownloadPdf = async () => {
        if (!formData) return;
        const financeData = childRef.current?.getFinanceData() || {};  // Fallback to empty object if not available
        const htmlContent = generateLeadHTML(
            formData,
            allComments,
            {
                ...leadDropdownData,
                states: [],
                areas: [],
                suburbs: [],
                realEstateAgents: filteredAgents
            },
            financeData,
        );

        // Create an off-screen container
        const hiddenElement = document.createElement("div");
        // hiddenElement.style.width = "800px";
        hiddenElement.style.padding = "20px";
        hiddenElement.style.backgroundColor = "white";
        hiddenElement.style.fontFamily = "Arial, sans-serif";
        hiddenElement.style.position = "absolute";
        hiddenElement.style.left = "-9999px";
        hiddenElement.innerHTML = htmlContent;

        document.body.appendChild(hiddenElement);
        const canvas = await html2canvas(hiddenElement, {
            scale: 2,
            useCORS: true,
            allowTaint: true
        });

        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        // pdf.save(`Lead_${formData.leadID}.pdf`);
        pdf.save(`Lead-${formData.leadID}-${formData.firstName}-${formData.surname?.toUpperCase()}.pdf`);
        // pdf.save(`Discovery_Call_${leadID}_${formData.clientName.replace(/\s+/g, '_')}.pdf`);

        document.body.removeChild(hiddenElement);
    };



    const handleEmailClick = () => {
        if (formData.email) {
            window.location.href = `mailto:${formData.email}`;
        } else {
            toast.error("No email address available for this lead");
        }
    };
    // Fetch builders data
    const {
        data: buildersData,
        isLoading: buildersLoading,
        isError: buildersIsError,
    } = useGetRequestQuery(
        ["getAllBuilders"],
        getAllBuildersService,
        {
            enabled: true,
        }
    );
    useEffect(() => {
        if (buildersData?.data && !buildersIsError && !buildersLoading) {
            const transformedData = buildersData.data.map((builder: any) => ({
                value: builder.supplierId,
                label: `${builder.supplier} - ${builder.bdmFirstName} ${builder.bdmLastName}`,
                areaId: builder.areaId,
                email: builder.bdmEmail
            }));
            console.log('Initial builders data:', buildersData?.data);
            console.log('Transformed builders data with emails:', transformedData);
            setBuildersOptions(transformedData);
            setFilteredAgents([]); // Initially show no agents
            console.log('Initial filtered agents set to empty');
        }
    }, [buildersData, buildersIsError, buildersLoading]);

    useEffect(() => {
        console.log('Area changed to:', formData.area);
        console.log('Current builders options:', buildersOptions);

        if (formData.area && formData.area !== "All" && formData.area !== "Any" && buildersOptions.length > 0) {
            // Filter agents that have matching areaId
            const filtered = buildersOptions.filter(agent => agent.areaId === parseInt(formData.area));
            console.log('Filtered agents for area', formData.area, ':', filtered);
            setFilteredAgents(filtered);
        } else {
            // When no area is selected, show no agents
            console.log('No area selected, setting filtered agents to empty');
            setFilteredAgents([]);
        }
    }, [formData.area, buildersOptions]);
    // Track previous area type to detect changes
    const [prevAreaType, setPrevAreaType] = useState<string>('');

    // Fetch filter areas when states and area type are selected
    useEffect(() => {
        const fetchFilterAreas = async () => {
            if (formData.location_State_Area_Suburb && formData.area && formData.area !== "Any" && formData.area !== "All") {
               try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Top3/filterarea?states=${formData.location_State_Area_Suburb}&areaType=${formData.area}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                    if (response.ok) {
                        const data = await response.json();
                        setFilterAreasData(data);

                        // Clean up selected areas - remove areas that are no longer available
                        if (selectedAreas) {
                            const currentAreaIds = selectedAreas.split(',').filter(id => id);
                            const availableAreaIds = data.map((area: any) => area.areaId.toString());
                            const validAreaIds = currentAreaIds.filter(id => availableAreaIds.includes(id));

                            if (validAreaIds.length !== currentAreaIds.length) {
                                setSelectedAreas(validAreaIds.join(','));
                            }
                        }

                        // Only clear selected areas if area type actually changed (not on initial load)
                        if (prevAreaType && prevAreaType !== formData.area) {
                            setSelectedAreas('');
                        }
                        setPrevAreaType(formData.area);
                    }
                } catch (error) {
                    console.error('Error fetching filter areas:', error);
                }
            } else {
                setFilterAreasData([]);
                if (prevAreaType) { // Only clear if not initial load
                    setSelectedAreas('');
                }
            }
        };

        fetchFilterAreas();
    }, [formData.location_State_Area_Suburb, formData.area, selectedAreas]);

    //const childRef = useRef<DiscoveryCallLeadRef>(null);
    const childRef = useRef<FinanceDetailsRef>(null);
    //   const strategyModalRef = useRef();

    const strategyModalRef = useRef<DiscoveryCallLeadRef>(null);

    // Function to trigger Discovery PDF from FinanceDetails
    const handleDownloadDiscoveryPdf = () => {
        // if (childRef.current) {
        //     // childRef.current.runChildFunction(); // Call FinanceDetails' runChildFunction
        // } else {
        //     toast.error("Finance Details component not found.");
        // }

        if (strategyModalRef.current) {
            strategyModalRef.current.downloadPdf();  // ✅ Call child’s function
        } else {
            toast.error("Strategy modal not found.");
        }
    };

    const handleButtonClick = () => {
        // Call child function when button is clicked
        childRef.current?.saveFinanceData();

    };

    const toggleStrategyModal = () => {
        setIsStrategyOpen(!isStrategyOpen);
    };
    // const strategyModalRef = useRef<DiscoveryCallLeadRef>(null);


    // const handleDownload = async () => {
    //   try {
    //     // const response = await fetch("http://localhost:44907/api/Top3/generate", {
    //     const response = await fetch("https://fintrack-be-gdasfffwhdhkgad2.australiaeast-01.azurewebsites.net/api/Top3/generate", {
    //       method: "POST",
    //       headers: { "Content-Type": "application/json" },
    //       body: JSON.stringify({ crmLeadId: leadID }),
    //     });

    //     if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    //     const data: Top3Response = await response.json();

    //     // Helper builders (always use TextRun for styling)
    //     const boldP = (txt: string, size = 24) =>
    //       new Paragraph({ children: [new TextRun({ text: txt, bold: true, size })] });

    //     const normalP = (txt: string | number | null, size = 22) =>
    //       new Paragraph({ children: [new TextRun({ text: txt == null ? "—" : String(txt), size })] });

    //     // ===== HEADER SECTION (bigger title + centered metadata) =====
    //     const headerSection = [
    //       new Paragraph({
    //         children: [
    //           new TextRun({
    //             text: "🏠 FINTRACK - TOP 3 PROPERTY SHORTLIST",
    //             bold: true,
    //             size: 48, // 24pt
    //             color: "2E74B5",
    //           }),
    //         ],
    //         alignment: "center",
    //         spacing: { after: 400 },
    //       }),
    //       new Paragraph({
    //         children: [new TextRun({ text: `Prepared for: ${data.clientName}`, size: 28 })],
    //         alignment: "center",
    //         spacing: { after: 300 },
    //       }),
    //       new Paragraph({
    //         children: [
    //           new TextRun({
    //             text: `Budget: ${data.budgetRangeRaw}    |    Strategy: ${data.strategyRequested}`,
    //             size: 24,
    //           }),
    //         ],
    //         alignment: "center",
    //         spacing: { after: 200 },
    //       }),
    //       new Paragraph({
    //         children: [
    //           new TextRun({
    //             text: `Property Type: ${data.propertyTypeRequested}    |    Contract Type: ${data.contractTypeRequested}    |    Beds/Baths/Cars: ${data.bedBathCarRequested}`,
    //             size: 22,
    //           }),
    //         ],
    //         alignment: "center",
    //         spacing: { after: 400 },
    //       }),
    //     ];

    //     // ===== PROPERTY DETAILS SECTION =====
    //     const propertySections = data.properties.map((p, index) => {
    //       const propertyHeader = new Paragraph({
    //         children: [
    //           new TextRun({
    //             text: `PROPERTY ${index + 1}: ${p.propertyAddress}`,
    //             bold: true,
    //             size: 40, // 20pt
    //             color: "1F4E79",
    //           }),
    //         ],
    //         spacing: { before: 300, after: 200 },
    //       });

    //       // Full width table (100%) with 4 equal columns (25% each).
    //       const propertyTable = new Table({
    //         width: { size: 100, type: WidthType.PERCENTAGE },
    //         // Optional borders for clean look
    //         borders: {
    //           top: { style: BorderStyle.SINGLE, size: 4, color: "auto" },
    //           bottom: { style: BorderStyle.SINGLE, size: 4, color: "auto" },
    //           left: { style: BorderStyle.SINGLE, size: 4, color: "auto" },
    //           right: { style: BorderStyle.SINGLE, size: 4, color: "auto" },
    //           insideHorizontal: { style: BorderStyle.SINGLE, size: 2, color: "auto" },
    //           insideVertical: { style: BorderStyle.SINGLE, size: 2, color: "auto" },
    //         },
    //         rows: [
    //           new TableRow({
    //             children: [
    //               new TableCell({
    //                 width: { size: 25, type: WidthType.PERCENTAGE },
    //                 margins: { top: 100, bottom: 100, left: 120, right: 120 },
    //                 children: [boldP("Type", 22)],
    //               }),
    //               new TableCell({
    //                 width: { size: 25, type: WidthType.PERCENTAGE },
    //                 margins: { top: 100, bottom: 100, left: 120, right: 120 },
    //                 children: [normalP(p.propertyType, 22)],
    //               }),
    //               new TableCell({
    //                 width: { size: 25, type: WidthType.PERCENTAGE },
    //                 margins: { top: 100, bottom: 100, left: 120, right: 120 },
    //                 children: [boldP("Contract Type", 22)],
    //               }),
    //               new TableCell({
    //                 width: { size: 25, type: WidthType.PERCENTAGE },
    //                 margins: { top: 100, bottom: 100, left: 120, right: 120 },
    //                 children: [normalP(p.contractType, 22)],
    //               }),
    //             ],
    //           }),
    //           new TableRow({
    //             children: [
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("Price", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(`$${p.price1BedroomRaw}`, 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("Yield %", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(`${p.rentYieldRaw}%`, 22)] }),
    //             ],
    //           }),
    //           new TableRow({
    //             children: [
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("Bedrooms", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(p.bedroomsRaw, 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("Bathrooms", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(p.bathRaw, 22)] }),
    //             ],
    //           }),
    //           new TableRow({
    //             children: [
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("Car Spots", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(p.carspotsRaw, 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("Points", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(p.totalPoints, 22)] }),
    //             ],
    //           }),
    //           new TableRow({
    //             children: [
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("Estate", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(p.estate, 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("Lot Number", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(p.lotNumber, 22)] }),
    //             ],
    //           }),
    //           new TableRow({
    //             children: [
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("Titled", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(p.titled, 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("Supplier ID", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(p.estate ?? "—", 22)] }),
    //             ],
    //           }),
    //               new TableRow({
    //             children: [
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("PropertyId", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(p.propertyId, 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [boldP("Supplier ID", 22)] }),
    //               new TableCell({ width: { size: 25, type: WidthType.PERCENTAGE }, children: [normalP(p.estate ?? "—", 22)] }),
    //             ],
    //           }),
    //         ],
    //       });

    //       return [propertyHeader, propertyTable];
    //     });

    //     // ===== DISCLAIMER SECTION =====
    //     const disclaimer = new Paragraph({
    //       children: [
    //         new TextRun({
    //           text:
    //             "Disclaimer: This report is confidential and prepared for informational purposes only. It should not be considered financial advice.",
    //           italics: true,
    //           size: 20,
    //         }),
    //       ],
    //       spacing: { before: 600 },
    //       alignment: "center",
    //     });

    //     // ===== FINAL DOCUMENT - reduced page margins to allow wider content =====
    //     const doc = new Document({
    //       sections: [
    //         {
    //           properties: {
    //             page: {
    //               margin: { top: 720, right: 720, bottom: 720, left: 720 }, // 0.5 inch margins
    //             },
    //           },
    //           children: [...headerSection, ...propertySections.flat(), disclaimer],
    //         },
    //       ],
    //     });

    //     const blob = await Packer.toBlob(doc);
    //     saveAs(blob, `${data.clientName}_Top3Properties.docx`);
    //     alert("✅ Report generated successfully!");
    //   } catch (error) {
    //     console.error("❌ Error generating DOCX:", error);
    //     alert("Failed to generate document.");
    //   }
    // };
    return (
        <>
            <div className={isMMPAssetsLiabilitiesRoute ? 'mmp-assets-liabilities container-fluid' : 'container-fluid'}>
                <div className="table-responsive h-100 py-4">

                    <div
                        ref={pdfRef}
                        className={isMMPAssetsLiabilitiesRoute ? 'mmp-assets-liabilities container-fluid' : 'container-fluid'}>

                        <section className='bg-white'>

                            <div className="scrollable-table-container">
                                {/*  width 98%.

                                         The table is nudged 1% to the right and was still 100% wide, so the
                                         whole page hung 14px past the right edge of the container around it -
                                         and that container has overflow auto with the scrollbar hidden, so
                                         those 14px could not be scrolled to. 98% plus the 1% margin lands
                                         inside it.  */}
                                    <table className="scrollable-table" style={{ marginLeft: '1%', marginTop: '3%', width: '98%' }}>
                                    <div className="d-flex align-items-center mb-3 mt-2">
                                        <H3 className="f-w-900 text-left mb-0" style={{ color: 'blue' }}>Edit Lead : {leadID}</H3>
                                        <div className="d-flex align-items-center mx-4">
                                            <Label className="mb-0 mr-2" style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>Date Created:</Label>
                                            <input
                                                type="text"
                                                name="createdOn"
                                                value={
                                                    formData.createdOn
                                                        ? new Date(formData.createdOn).toLocaleDateString('en-GB')
                                                        : ''
                                                }
                                                readOnly
                                                className="form-control"
                                                style={{ width: '150px', height: '32px', fontSize: '13px' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center mb-3 flex-wrap">
                                        <div className="d-flex mr-4">
                                            <Button className="mx-1" onClick={handleSubmit} disabled={isManageLeadPending || !isDataLoaded || isLoading} color="primary" style={{ padding: '6px 12px', fontSize: '13px' }}>{isManageLeadPending ? "Loading . . ." : isLoading ? "Loading Data..." : "Update Lead"}</Button>
                                            <Button onClick={handleDownloadPdf} className="mx-1" color="info" style={{ padding: '6px 12px', fontSize: '13px' }}>Lead - PDF</Button>
                                            <Button className="mx-1" color="primary" onClick={handleEmailClick} style={{ padding: '6px 12px', fontSize: '13px' }}>Email Client</Button>
                                            <Button className="mx-1" color="primary" onClick={toggle} style={{ padding: '6px 12px', fontSize: '13px' }}>SMS</Button>
                                            <Button className="mx-1" color="primary" onClick={toggleFileUpload} style={{ padding: '6px 12px', fontSize: '13px' }}>Upload Document</Button>
                                            <Button className="mx-1" color="success" onClick={handleTop3Download} style={{ padding: '6px 12px', fontSize: '13px' }}>Top 3</Button>
                                            <Button className="mx-1" style={{ backgroundColor: '#6f42c1', borderColor: '#6f42c1', color: 'white', padding: '6px 12px', fontSize: '13px' }} onClick={handleOpenLoanEnquiry}>Loan Enquiry</Button>
                                            {/* Straight into this client's Gameplan, staff side. Own tab, so the
                                                lead screen stays where it was, and the CRM's own copy of the page
                                                so the staff session goes with it - the public one on
                                                fintrack.com.au has no session to read a client's record with.

                                                The comment belongs out here. A C style comment inside the tag is
                                                not a JSX comment, and it took the styling down with it. */}
                                            <Button
                                                className="mx-1 btn-gameplan"
                                                style={{ padding: '6px 12px', fontSize: '13px' }}
                                                onClick={() => window.open(`/gameplan.html?client=${leadID}`, '_blank', 'noopener,noreferrer')}
                                            >Gameplan</Button>
                                            {isSignedMbLead && (
                                                <Button
                                                    className="mx-1"
                                                    color="success"
                                                    disabled={isConverting}
                                                    onClick={handleConvertToPlatform}
                                                    style={{ padding: '6px 12px', fontSize: '13px', fontWeight: 700 }}
                                                >{isConverting ? "Converting . . ." : "Convert to Platform"}</Button>
                                            )}
                                            <Button className="mx-1" color="danger" onClick={() => {
                                                if (window.history.length > 2) {
                                                    window.history.back();
                                                } else {
                                                    navigate('/CRMTaskList');
                                                }
                                            }} style={{ padding: '6px 12px', fontSize: '13px' }}>
                                                Back
                                            </Button>
                                        </div>
                                    </div>

                                    <div style={{ height: '3px', backgroundColor: '#4361ee', width: '100%', marginBottom: '20px' }} />

                                    {/*  mx-0.

                                         A Bootstrap Row carries negative side margins, and the element that
                                         normally absorbs them is a container with matching padding. Here the
                                         Row's parent is the page's own <table>, which has none, so the Row sat
                                         9px wider than the table on each side. The table is inside a container
                                         with overflow auto and the scrollbar switched off, so those 9px were
                                         not just off the edge - they could not be scrolled to either.

                                         Nothing showed it while the right half of this row was empty. Put the
                                         Business Builder panel there and its status badge and its Copy link and
                                         Cancel buttons - all of them hard against the panel's right edge - were
                                         the first things to fall into the gap. Taking the negative margins off
                                         keeps the row inside the table; the columns' own padding is untouched. */}
                                    <Row className="mx-0">
                                        <Col lg={6} xl={6}>
                                            <div className='d-flex item-center mb-3 mt-2'>
                                                <Col xs={3} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px' }}>First Name:</Label></Col>
                                                <Col xs={4} style={{ paddingInline: '2px' }}>
                                                    <TextField label="" type="text" name="firstName" value={formData.firstName} setValue={handleValueChange} placeholder="" design="flex" passCol="col-12" maxChars={20} tabIndex={1} />
                                                </Col>
                                                <Col xs={2} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px', marginLeft: '10px' }}>Source:</Label></Col>
                                                <Col xs={3} style={{ paddingInline: '2px' }}>
                                                    <DropdownWithValueName label="" name="source" value={formData.source} setValue={handleValueChange} options={leadDropdownData?.leadSources || []} passCol="col-12" design="flex" tabIndex={1} />
                                                </Col>
                                            </div>
                                            <div className='d-flex item-center mb-3'>
                                                <Col xs={3} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px' }}>Surname:</Label></Col>
                                                <Col xs={4} style={{ paddingInline: '2px' }}>
                                                    <TextField label="" type="text" name="surname" value={formData.surname} setValue={handleValueChange} placeholder="" design="flex" passCol="col-12" maxChars={20} tabIndex={1} style={{ textTransform: 'uppercase' }} />
                                                </Col>
                                                <Col xs={2} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px', marginLeft: '10px' }}>Staff:</Label></Col>
                                                <Col xs={3} style={{ paddingInline: '2px' }}>
                                                    <DropdownWithValueName label="" name="staff" value={formData.staff} setValue={handleValueChange} options={leadDropdownData?.staff || []} passCol="col-12" design="flex" tabIndex={1} />
                                                </Col>
                                            </div>
                                            <div className='d-flex item-center mb-3'>
                                                <Col xs={3} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px' }}>Email:</Label></Col>
                                                <Col xs={4} style={{ paddingInline: '2px' }}>
                                                    <TextField label="" type="email" name="email" value={formData.email} setValue={handleValueChange} placeholder="" design="flex" passCol="col-12" maxChars={40} tabIndex={1} />
                                                </Col>
                                                <Col xs={2} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px', marginLeft: '10px' }}>Stage:</Label></Col>
                                                <Col xs={3} style={{ paddingInline: '2px' }}>
                                                    <DropdownWithValueName label="" name="stage" value={formData.stage} setValue={handleValueChange} options={stagesOptions} passCol="col-12" design="flex" tabIndex={1} placeholder="Select" />
                                                </Col>
                                            </div>
                                            <div className='d-flex item-center mb-3'>
                                                <Col xs={3} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px' }}>Mobile:</Label></Col>
                                                <Col xs={4} style={{ paddingInline: '2px' }}>
                                                    <MobileField label="" mobileField="mobile" value={formData.mobile} setValue={(field, value) => handleValueChange(field, value)} placeholder="" design="flex" passCol="col-12" maxLength={14} tabIndex={1} />
                                                </Col>
                                                <Col xs={2} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px', marginLeft: '10px' }}>Follow Up:</Label></Col>
                                                <Col xs={3} style={{ paddingInline: '2px' }}>
                                                    <SelectDatePicker label="" name="followUp" value={formData.followUp} setValue={handleValueChange} passCol="col-12" design="flex" tabIndex={1} />
                                                </Col>
                                            </div>

                                            {isMbLead && (
                                                <>
                                                    <div className='d-flex item-center mb-3'>
                                                        <Col xs={3} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px' }}>Company Name:</Label></Col>
                                                        <Col xs={4} style={{ paddingInline: '2px' }}>
                                                            <TextField label="" type="text" name="companyName" value={formData.companyName} setValue={handleValueChange} placeholder="" design="flex" passCol="col-12" maxChars={100} tabIndex={1} />
                                                        </Col>
                                                        <Col xs={2} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px', marginLeft: '10px' }}>ABN:</Label></Col>
                                                        <Col xs={3} style={{ paddingInline: '2px' }}>
                                                            <TextField label="" type="text" name="abn" value={formatAbn(formData.abn)} setValue={(name: string, value: any) => handleValueChange(name, formatAbn(String(value ?? "")))} placeholder="99 006 164 709" design="flex" passCol="col-12" maxChars={ABN_INPUT_MAX_LEN} tabIndex={1} />
                                                        </Col>
                                                    </div>
                                                    <div className='d-flex item-center mb-3'>
                                                        <Col xs={3} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px' }}>State:</Label></Col>
                                                        <Col xs={4} style={{ paddingInline: '2px' }}>
                                                            <DropdownWithValueName label="" name="address" value={formData.address} setValue={handleValueChange} options={AU_STATES} passCol="col-12" design="flex" tabIndex={1} />
                                                        </Col>
                                                        <Col xs={2} style={{ paddingInline: '2px' }}><Label className="mb-0" style={{ fontSize: '13px', marginLeft: '10px' }}>ACN:</Label></Col>
                                                        <Col xs={3} style={{ paddingInline: '2px' }}>
                                                            <TextField label="" type="text" name="acn" value={formatAcn(formData.acn)} setValue={(name: string, value: any) => handleValueChange(name, formatAcn(String(value ?? "")))} placeholder="006 164 709" design="flex" passCol="col-12" maxChars={ACN_INPUT_MAX_LEN} tabIndex={1} />
                                                        </Col>
                                                    </div>
                                                </>
                                            )}

                                        </Col>

                                        {/* Fintrack's own e-signature for the Business Builder agreement.
                                            MB leads only - it is the only kind of lead this agreement
                                            belongs to.

                                            Beside the lead, not beneath it. The right half of this row was
                                            empty, and this panel is the thing you act on while you are
                                            reading the lead - sending it, or seeing whether it was opened. */}
                                        {isMbLead && (
                                            <Col lg={6} xl={6}>
                                                <LeadAgreement leadId={leadID} formData={formData} />
                                            </Col>
                                        )}

                                    </Row>



                                    {/* ===== New Section: Discovery Preferences ===== */}

                                    <div style={{ height: '2px', backgroundColor: 'blue', width: '100%', marginTop: '4px' }} />

                                    {/* Richard, 11 Oct 2026: "MB remove the Property stuff". Budget & Strategy,
                                        Property Preferences and Location are questions for somebody buying a
                                        property. A mortgage broker is being sold Business Builder, so on his
                                        lead they sat empty between the proposal and the comments.

                                        Hidden, not removed from the page: whatever the lead already holds in
                                        those fields stays in the form and is saved back untouched, and it is
                                        all there again if the lead is moved to a client stage. */}
                                    <div style={{ display: isMbLead ? 'none' : undefined }}>

                                        {/* <div className="d-flex align-items-center">
                                            <Col xs={12} className='d-flex'>
                                                <h3 className="heading-color f-w-900 text-left my-2">Client Preferences</h3>
                                            </Col>
                                        </div> */}
                                        {/* Row 1: Budget + Property Preferences */}
                                        <div className="row mt-2">
                                            {/* Section 1: Budget Range */}
                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <h4 style={{ fontSize: '16px', fontWeight: 'bold', color: 'blue', marginBottom: '15px' }}>Budget & Strategy</h4>
                                                </div>
                                                <div className="mb-2 d-flex align-items-center">
                                                    <Col xs={6}>
                                                        <Label className="me-2  ">What is Your Budget ?</Label>

                                                    </Col>


                                                    <Col xs={6}>

                                                        <DollarInput
                                                            label=""
                                                            name="houseValue"
                                                            value={formData.houseValue}
                                                            setValue={handleValueChange}
                                                            passCol="col-9"
                                                            design="flex"
                                                            tabIndex={18}
                                                            limit={10}
                                                        />

                                                    </Col>
                                                </div>

                                                {/* future extra inputs niche add karne ke liye */}
                                                {/* <div className="mb-2 d-flex align-items-center">
                                                    <Col xs={6}>
                                                        <Label className="mb-2">Finance Approved:</Label>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <Dropdown
                                                            label=""
                                                            name="taxableIncome"
                                                            value={formData.taxableIncome}
                                                            setValue={handleValueChange}
                                                            options={[
                                                                "Yes I have approval", "No - Arranging approval", "No - Need your help"
                                                            ]}
                                                            passCol="col-9"
                                                            design="flex"
                                                            tabIndex={18}
                                                        />
                                         
                                                    </Col>

                                                </div> */}

                                                <div className="mb-2 d-flex align-items-center">
                                                    <Col xs={6}>
                                                        <Label className="mb-2">What is your Strategy ?</Label>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <Dropdown
                                                            label=""
                                                            name="realEstateAgent1"   // B
                                                            value={formData.realEstateAgent1}
                                                            setValue={handleValueChange}
                                                            options={["Cashflow", "Growth", "Balanced"]}
                                                            passCol="col-9"
                                                            design="flex"
                                                            tabIndex={18}
                                                        />
                                                    </Col>

                                                </div>



                                                <div className="mb-2 d-flex align-items-center">
                                                    <Col xs={6}>
                                                        <Label className="mb-2">Contract Type</Label>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <Dropdown
                                                            label=""
                                                            name="propertyPurpose"   // A
                                                            value={formData.propertyPurpose}
                                                            setValue={handleValueChange}
                                                            options={["All", "Two Part", "One Part"]}
                                                            passCol="col-9"
                                                            design="flex"
                                                            tabIndex={18}
                                                        />
                                                    </Col>

                                                </div>

                                                <div className="mb-2 d-flex align-items-center">
                                                    <Col xs={6}>
                                                        <Label className="mb-2">Property Ready</Label>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <Dropdown
                                                            label=""
                                                            name="propertyReady"
                                                            value={formData.propertyReady}
                                                            setValue={handleValueChange}
                                                            options={["All", "Available now", "Titled Later"]}
                                                            passCol="col-9"
                                                            design="flex"
                                                            tabIndex={19}
                                                        />
                                                    </Col>
                                                </div>

                                            </div>

                                            {/* Section 2: Property Type */}
                                            <div className="col-md-4">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h4 style={{ fontSize: '16px', fontWeight: 'bold', color: 'blue', marginBottom: 0 }}>Property Preferences</h4>
                                                    <div className="d-flex align-items-center">
                                                        <span style={{ fontSize: '13px', marginRight: '5px' }}>Any property</span>
                                                        <Input
                                                            type="checkbox"
                                                            name="propertyType"
                                                            checked={!formData.propertyType || formData.propertyType === "Any" || formData.propertyType === ""}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    handleValueChange("propertyType", "Any");
                                                                } else {
                                                                    handleValueChange("propertyType", "");
                                                                }
                                                            }}
                                                            tabIndex={19}
                                                            style={{ margin: 0, width: '16px', height: '16px' }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* <div className="mb-2 d-flex align-items-center">
                                                    <Col xs={6}>
                                                        <Label className="mb-2">New OR Old:</Label>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <Dropdown
                                                            label=""
                                                            name="realEstateAgent3"
                                                            value={formData.realEstateAgent3}
                                                            setValue={handleValueChange}
                                                            options={["Any", "Brand New", "Established"]}
                                                            passCol="col-9"
                                                            design="flex"
                                                            tabIndex={19}
                                                        />
                                                    </Col>
                                                </div>


                                                <div className="mb-2 d-flex align-items-center">
                                                    <Col xs={6}>
                                                        <Label className="mb-2">Invest OR Live in:</Label>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <Dropdown
                                                            label=""
                                                            name="realEstateAgent2"
                                                            value={formData.realEstateAgent2}
                                                            setValue={handleValueChange}
                                                            options={["Any", "Yes Invest", "No Live in"]}
                                                            passCol="col-9"
                                                            design="flex"
                                                            tabIndex={19}
                                                        />
                                                    </Col>
                                                </div> */}




                                                {/* future extra inputs niche add karne ke liye */}
                                                {/* <div className="mb-2 d-flex align-items-center">
                                                    <Col xs={6}>
                                                        <Label className="mb-2">Bed / Bath / Car:</Label>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <TextField
                                                            label=""
                                                            type="text"
                                                            name="location_Beds_Baths_Cars"
                                                            value={formData.location_Beds_Baths_Cars}
                                                            setValue={handleValueChange}
                                                            placeholder="e.g. 3/2/1"
                                                            design="flex"
                                                            passCol="col-9"
                                                            maxChars={5}
                                                            tabIndex={19}
                                                        />
                                                    </Col>
                                                </div> */}




                                                <div className="mb-2">
                                                    <Col xs={12}>

                                                        <div className="row">
                                                            {/* STANDARD Section */}
                                                            <div className="col-6 pr-1">
                                                                <Label style={{ fontWeight: 'bold', fontSize: '13px', color: '#333', display: 'block', marginBottom: '8px' }}>
                                                                    STANDARD
                                                                </Label>
                                                                {["Apartment", "House & Land", "Town House", "Unit"].map((type: string) => (
                                                                    <div key={type} className="d-flex justify-content-between align-items-center mb-1" style={{ maxWidth: '180px' }}>
                                                                        <span style={{ fontSize: '13px' }}>{type === "Town House" ? "Townhouse" : type}</span>
                                                                        <Input
                                                                            type="checkbox"
                                                                            name="propertyType"
                                                                            checked={formData.propertyType?.split(',').includes(type) || false}
                                                                            onChange={(e) => {
                                                                                const currentTypes = formData.propertyType && formData.propertyType !== "Any"
                                                                                    ? formData.propertyType.split(',').filter((t: string) => t.trim() !== "")
                                                                                    : [];

                                                                                let updatedTypes = e.target.checked
                                                                                    ? [...currentTypes, type]
                                                                                    : currentTypes.filter((t: string) => t !== type);

                                                                                const newValue = updatedTypes.length > 0 ? updatedTypes.join(',') : "Any";
                                                                                handleValueChange("propertyType", newValue);
                                                                            }}
                                                                            tabIndex={19}
                                                                            style={{ margin: 0, width: '16px', height: '16px' }}
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            {/* HIGH YIELD Section */}
                                                            <div className="col-6 pl-1">
                                                                <Label style={{ fontWeight: 'bold', fontSize: '13px', color: '#333', display: 'block', marginBottom: '8px' }}>
                                                                    HIGH YIELD
                                                                </Label>
                                                                {["Co Living", "Dual Income", "NDIS", "Rooming"].map((type: string) => (
                                                                    <div key={type} className="d-flex justify-content-between align-items-center mb-1" style={{ maxWidth: '180px' }}>
                                                                        <span style={{ fontSize: '13px' }}>{type}</span>
                                                                        <Input
                                                                            type="checkbox"
                                                                            name="propertyType"
                                                                            checked={formData.propertyType?.split(',').includes(type) || false}
                                                                            onChange={(e) => {
                                                                                const currentTypes = formData.propertyType && formData.propertyType !== "Any"
                                                                                    ? formData.propertyType.split(',').filter((t: string) => t.trim() !== "")
                                                                                    : [];

                                                                                let updatedTypes = e.target.checked
                                                                                    ? [...currentTypes, type]
                                                                                    : currentTypes.filter((t: string) => t !== type);

                                                                                const newValue = updatedTypes.length > 0 ? updatedTypes.join(',') : "Any";
                                                                                handleValueChange("propertyType", newValue);
                                                                            }}
                                                                            tabIndex={19}
                                                                            style={{ margin: 0, width: '16px', height: '16px' }}
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </div>



                                            </div>

                                            {/* Section 3: States */}



                                        </div>

                                        <div className='d-flex item-center mt-2'>

                                            <Col xs={2}>
                                                <Label className="mb-2" style={{ fontSize: '16px', fontWeight: 'bold', color: 'blue' }}>Location</Label>
                                            </Col> <Col xs={2}>
                                                <Label className="mb-2"> </Label>
                                            </Col>
                                        </div>

                                        <div className="row mt-2">
                                            <div className="col-12">
                                                <div className="mb-2 d-flex align-items-center flex-wrap">
                                                    <Label className="mb-0" style={{ fontSize: '13px', fontWeight: 'normal', minWidth: '120px', marginRight: '15px' }}>State(s) preferred</Label>
                                                    <div className="d-flex flex-wrap gap-2 mt-1 align-items-center">
                                                        <FormGroup check inline className="mb-0">
                                                             <Input
                                                                 type="checkbox"
                                                                 name="select_all_states"
                                                                 checked={isAllStatesSelected()}
                                                                 onChange={handleToggleAllStates}
                                                                 tabIndex={20}
                                                             />
                                                             <Label check style={{ fontWeight: 'bold' }}>All</Label>
                                                        </FormGroup>
                                                        {allStatesLoading && <span style={{ fontSize: '13px', marginLeft: '10px' }}>Loading states...</span>}
                                                        {!allStatesLoading && (() => {
                                                            const sortedStates = (allStatesData?.data || []).slice().sort((a: any, b: any) => (a.name || "").localeCompare(b.name || ""));
                                                            return sortedStates.map((stateObj: any) => {
                                                                const stateName = stateObj.name;
                                                                if (!stateName) return null;
                                                                const isChecked = formData.location_State_Area_Suburb?.split(',').map((s: string) => s.trim()).includes(stateName) || false;
                                                                return (
                                                                    <FormGroup check inline key={stateObj.id} className="mb-0">
                                                                        <Input
                                                                            type="checkbox"
                                                                            name="location_State_Area_Suburb"
                                                                            checked={isChecked}
                                                                            onChange={(e) => {
                                                                                const currentStates = formData.location_State_Area_Suburb
                                                                                    ? formData.location_State_Area_Suburb.split(',').map((s: string) => s.trim()).filter(Boolean)
                                                                                    : [];

                                                                                let updatedStates = e.target.checked
                                                                                    ? [...currentStates, stateName]
                                                                                    : currentStates.filter((s: string) => s !== stateName);

                                                                                handleValueChange("location_State_Area_Suburb", updatedStates.join(','));
                                                                            }}
                                                                            tabIndex={20}
                                                                        />
                                                                        <Label check>{stateName}</Label>
                                                                    </FormGroup>
                                                                );
                                                            });
                                                        })()}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mt-2">


                                            <div className="col-md-6">
                                                <div className="mb-3 d-flex align-items-center">
                                                    <Col xs={4}>
                                                        <Label className="mb-2">Metro or Regional area?</Label>
                                                    </Col>
                                                    <Col xs={8}>
                                                        <Dropdown
                                                            label=""
                                                            name="area"
                                                            value={formData.area}
                                                            setValue={handleValueChange}
                                                            options={["All", "Metro", "Regional"]}
                                                            passCol="col-9"
                                                            design="flex"
                                                            tabIndex={20}
                                                        />
                                                    </Col>
                                                </div>
                                            </div>

                                            {/* <div className="col-md-2">
                                                <div className="mb-2 d-flex align-items-center">
                                                    <Col xs={4}>
                                                        <Label className="mb-2">Titled:</Label>
                                                    </Col>
                                                    <Col xs={8}>
                                                        <Dropdown
                                                            label=""
                                                            name="combinedSuper"
                                                            value={formData.combinedSuper}
                                                            setValue={handleValueChange}
                                                            options={["Any", "Titled"]}
                                                            passCol="col-9"
                                                            design="flex"
                                                            tabIndex={20}
                                                        />
                                                    </Col>
                                                </div>
                                            </div> */}

                                        </div>


                                        <div className="row mt-2">
                                            <div className="col-md-12">
                                                {formData.area && formData.area !== "Any" && formData.area !== "All" && formData.location_State_Area_Suburb && (
                                                    <div className="mb-2">
                                                        <FilterAreasSelector
                                                            filterAreasData={filterAreasData}
                                                            selectedAreas={selectedAreas}
                                                            onSelectionChange={setSelectedAreas}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Row 2: Invest/Owner + New/Old */}
                                        {/* <div className='d-flex item-center mt-2'>
                                            <Col xs={2}>
                                                <Label className="mb-2">Invest or Owner:</Label>
                                            </Col>
                                            <Col xs={3}>
                                                <Dropdown
                                                    label=""
                                                    name="realEstateAgent1"
                                                    value={formData.realEstateAgent1}
                                                    setValue={handleValueChange}
                                                    options={["Investor", "Owner Occupier"]}
                                                    passCol="col-9"
                                                    design="flex"
                                                    tabIndex={18}

                                                />
                                            </Col>
                                            <Col xs={2}>
                                                <Label className="mb-2">New or Old:</Label>
                                            </Col>
                                            <Col xs={3}>
                                                <Dropdown
                                                    label=""
                                                    name="propertyPurpose"
                                                    value={formData.propertyPurpose}
                                                    setValue={handleValueChange}
                                                    options={["New", "Established"]}
                                                    passCol="col-9"
                                                    design="flex"
                                                    tabIndex={18}
                                                />
                                            </Col>
                                        </div> */}



                                        {/* Row 4: States Preferred */}


                                        {/* Row 5: Areas + Suburbs */}
                                        {/* <div className='d-flex item-center mt-2'>
                                           
                                            <Col xs={2}>
                                                <Label className="mb-2">Suburbs Preferred:</Label>
                                            </Col>
                                            <Col xs={3}>
                                                <TextField
                                                    type="text"   // ✅ Added

                                                    label=""
                                                    name="suburb"
                                                    value={formData.suburb}
                                                    setValue={handleValueChange}
                                                    placeholder="Enter Suburb"
                                                    design="flex"
                                                    maxChars={50}
                                                    tabIndex={18}

                                                    passCol="col-9"
                                                />
                                            </Col>
                                        </div> */}





                                        {/* Row X: Contract Type + Strategy Type */}


                                        {/* Row X: Gearing + Tax Rate */}


                                        {/* Row X: KM to Rail + KM to CBD */}
                                        {/* <div className='d-flex item-center mt-2'>
                                            <Col xs={2}>
                                                <Label className="mb-2">Gearing:</Label>
                                            </Col>
                                            <Col xs={2}>
                                                <Dropdown
                                                    label=""
                                                    name="combinedSuper"   // C
                                                    value={formData.combinedSuper}
                                                    setValue={handleValueChange}
                                                    options={["Any", "Negative", "Neutral", "Positive"]}
                                                    passCol="col-9"
                                                    design="flex"
                                                    tabIndex={18}
                                                />
                                            </Col>


                                        </div> */}





                                    </div>








                                    {/* <DiscoveryCallLead/> */}

                                    {/*<DiscoveryCallLead ref={childRef} />*/}

                                    {/* <FinanceDetails ref={childRef} leadId={leadID} />. */}




                                    <div className="my-3 p-3" style={{ border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', background: '#fff' }}>
                                        <div className="d-flex align-items-center">
                                            <Col xs={12} className='d-flex'>
                                                <h3 className="heading-color f-w-900 text-left my-2">Lead Comments</h3>
                                            </Col>
                                        </div>
                                        {/* <Col className="responsive-col" xs={12} style={{ width: '85%', paddingInline: '2px' }}> */}
                                        <div className="d-flex gap-2">
                                            <TextField
                                                label=""
                                                type="textarea"
                                                name="comment"
                                                value={formData.comment}
                                                setValue={handleValueChange}
                                                placeholder=""
                                                design="default"
                                                passCol="col-8"
                                                tabIndex={21}
                                                rows={5}
                                                style={{ width: "70rem" }} // Set your desired width
                                            />
                                            <Button color="primary" onClick={handleAddComment} disabled={isUpdateCommentPending}>
                                                {isUpdateCommentPending ? "Loading . . ." : "Update Comment"}
                                            </Button>
                                        </div>

                                        {/* </Col> */}
                                        {allComments.length > 0 && (
                                            <ListGroup className="mt-3">
                                                {allComments.map((comment: any, index: any) => (
                                                    <ListGroupItem key={index} className="flex-column">
                                                        {/* Date and Staff Name Left-Aligned with Space */}
                                                        <div className="d-flex justify-content-between">
                                                            <span>
                                                                <strong>Date:</strong> {new Date(comment.createdOn).toLocaleString("en-GB", {
                                                                    year: "numeric",
                                                                    month: "2-digit",
                                                                    day: "2-digit",
                                                                }).replace(",", "")}
                                                            </span>
                                                            <span>
                                                                <strong>Staff Name:</strong> {`${(leadDropdownData?.staff?.find((s: any) => s.value == comment?.staff)?.label) || ""}`}
                                                            </span>
                                                        </div>
                                                        <div className="mt-2">{comment.commentText}</div>
                                                    </ListGroupItem>
                                                ))}
                                            </ListGroup>
                                        )}
                                    </div>
                                    <DocumentList leadID={leadID} />
                                    <StageHistory leadID={leadID} />

                                </table>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <SendSms toggle={toggle} open={modal} mobileNumber={formData.mobile} leadId={leadID} staffId={userID} />
            <FileUpload open={isFileUploadOpen} toggle={toggleFileUpload} leadId={leadID} />
            <StrategyModal ref={strategyModalRef} toggleStrategyModal={toggleStrategyModal} open={isStrategyOpen} leadId={leadID} />

        </>
    );
}
